export default "__VITE_ASSET__JVSosj8l__"